export default function isOverFlown(element) {
    if (element) {
        return (
            element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth
        );
    }
    return false;
}
